var map = {
	"./dist/config/config.json": 292,
	"./dist/modules/__TypePolicies.json": 186,
	"./dist/modules/_module_demo_/module.json": 135,
	"./dist/modules/_module_demo_/translation/en.json": 187,
	"./dist/modules/_module_demo_/translation/it.json": 188,
	"./dist/modules/assistant/module.json": 136,
	"./dist/modules/assistant/translation/en.json": 143,
	"./dist/modules/assistant/translation/it.json": 144,
	"./dist/modules/dashboard/module.json": 137,
	"./dist/modules/dashboard/translation/en.json": 189,
	"./dist/modules/dashboard/translation/it.json": 190,
	"./dist/modules/kitchen-order-ticket/module.json": 138,
	"./dist/modules/kitchen-order-ticket/translation/en.json": 191,
	"./dist/modules/kitchen-order-ticket/translation/it.json": 192,
	"./dist/modules/menu-management/module.json": 139,
	"./dist/modules/menu-management/server/utils/AllergensAndFoodTypes.json": 182,
	"./dist/modules/menu-management/translation/en.json": 193,
	"./dist/modules/menu-management/translation/it.json": 194,
	"./dist/modules/profile/module.json": 140,
	"./dist/modules/profile/translation/en.json": 195,
	"./dist/modules/profile/translation/it.json": 196,
	"./dist/modules/settings/module.json": 141,
	"./dist/modules/settings/translation/en.json": 197,
	"./dist/modules/settings/translation/it.json": 198,
	"./dist/modules/shop/module.json": 142,
	"./dist/modules/shop/translation/en.json": 199,
	"./dist/modules/shop/translation/it.json": 200,
	"./package.json": 558,
	"./src/config/config.json": 559,
	"./src/modules/__TypePolicies.json": 284,
	"./src/modules/_module_demo_/module.json": 275,
	"./src/modules/_module_demo_/translation/en.json": 560,
	"./src/modules/_module_demo_/translation/it.json": 561,
	"./src/modules/assistant/module.json": 276,
	"./src/modules/assistant/translation/en.json": 562,
	"./src/modules/assistant/translation/it.json": 563,
	"./src/modules/dashboard/module.json": 277,
	"./src/modules/dashboard/translation/en.json": 564,
	"./src/modules/dashboard/translation/it.json": 565,
	"./src/modules/kitchen-order-ticket/module.json": 278,
	"./src/modules/kitchen-order-ticket/translation/en.json": 566,
	"./src/modules/kitchen-order-ticket/translation/it.json": 567,
	"./src/modules/menu-management/module.json": 279,
	"./src/modules/menu-management/server/utils/AllergensAndFoodTypes.json": 568,
	"./src/modules/menu-management/translation/en.json": 569,
	"./src/modules/menu-management/translation/it.json": 570,
	"./src/modules/profile/module.json": 280,
	"./src/modules/profile/translation/en.json": 571,
	"./src/modules/profile/translation/it.json": 572,
	"./src/modules/settings/module.json": 281,
	"./src/modules/settings/translation/en.json": 573,
	"./src/modules/settings/translation/it.json": 574,
	"./src/modules/shop/module.json": 282,
	"./src/modules/shop/translation/en.json": 575,
	"./src/modules/shop/translation/it.json": 576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 557;